import { Dictionary } from 'vue-router/types/router'

type Query = Dictionary<string | (string | null)[] | null | undefined>

// Параметры запроса страницы списка (раздел, бренд, коллекция) для API.
// ?page= без значения Nuxt на сервере превращает в ?page, vue-router отдаёт его
// как null, а axios такие параметры выбрасывает — API получал запрос без page
// и отдавал первую страницу с кодом 200. Передаём пустое значение: на
// некорректный номер страницы API отвечает 404.
export function listQuery(query: Query): Query {
  const params = { ...query }
  if ('page' in params && (params.page === null || params.page === undefined)) {
    params.page = ''
  }
  return params
}
